<mp-toolbar
  [user]="user | async"
  [roles]="roles | async"
  [cartItems]="cartItems | async"
></mp-toolbar>
<main class="main">
  <div class="main__content-wrapper"><router-outlet></router-outlet></div>
  <mp-footer></mp-footer>
</main>
